// frontend/src/components/BookList.js
import React, { useState, useEffect, memo, useCallback, useMemo, useRef } from 'react'; // useRef hinzugefügt
import './BookList.css';
import BookTable from './BookTable';
import BookSearch from './BookSearch';
import BookPagination from './BookPagination';
import BookDetail from './BookDetail';
import BarcodeScanner from './BarcodeScanner';
import LocationDialog from './LocationDialog';
import MassImportDialog from './MassImportDialog';
import UserAccount from './UserAccount';
import StatsDialog from './StatsDialog';
import UserProfile from './UserProfile';
import { useTheme } from '@mui/material/styles'; // <-- HIER HINZUGEFÜGT
import {
    Box, Button, Autocomplete, TextField, Dialog, DialogTitle, DialogContent, DialogActions,
    IconButton, Typography, CircularProgress, Paper, Snackbar, Alert, Stack,
    AppBar, Toolbar, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider,
    SpeedDial, SpeedDialIcon, SpeedDialAction, useMediaQuery,
    Badge,
    Chip, // <-- Chip hinzugefügt
    DialogContentText, // <-- Hinzugefügt für Logout-Dialog
    TableContainer // <-- HINZUGEFÜGT für ausgeliehene Bücher
} from '@mui/material';
// ... andere Icon Imports ...
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import FilterListIcon from '@mui/icons-material/FilterList'; // Hinzugefügt für Filter-Button
import LocationOnIcon from '@mui/icons-material/LocationOn';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import BarChartIcon from '@mui/icons-material/BarChart';
import AddIcon from '@mui/icons-material/Add';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import SaveIcon from '@mui/icons-material/Save';
import ClearAllIcon from '@mui/icons-material/ClearAll'; // Für "Alle Bücher"
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'; // Für "Gelesen"
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder'; // Für "Will ich lesen"
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'; // Für "Behalten"
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'; // Für "Kann weg"
import BackspaceIcon from '@mui/icons-material/Backspace'; // <-- Icon für Chip-Löschen
import ExitToAppIcon from '@mui/icons-material/ExitToApp'; // <-- Icon für Logout-Bestätigung
import RateReviewIcon from '@mui/icons-material/RateReview'; // <-- NEUES Icon
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'; // Importiere ein passendes Icon
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom'; // <-- NEU useNavigate importieren

import { useAuth } from '../hooks/useAuth';
import { useLocations } from '../hooks/useLocations';
import { useUserPreferences } from '../context/UserPreferencesContext';
import { useBooks } from '../hooks/useBooks';
import BookCardList from './BookCardList';
import { fetchCurrentLoansAPI, returnBookAPI } from '../services/api';

// Helper für Location Label (bleibt gleich)
const getLocationLabel = (location) => {
    if (!location) return '';
    let label = location.adresse || '';
    if (location.raum) label += ` / ${location.raum}`;
    if (location.regal) label += ` / ${location.regal}`;
    if (location.fach) label += ` / ${location.fach}`;
    if (!label && location.name) return location.name;
    return label || 'Unbekannter Ort';
};

// *** NEU: Komponente für den Logout-Bestätigungsdialog ***
const ConfirmLogoutDialog = ({ open, onClose, onConfirm }) => (
    <Dialog open={open} onClose={onClose}>
        <DialogTitle>Abmelden bestätigen</DialogTitle>
        <DialogContent>
            <DialogContentText>
                Möchtest du dich wirklich abmelden?
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>Abbrechen</Button>
            <Button onClick={onConfirm} color="primary" startIcon={<ExitToAppIcon />}>
                Abmelden
            </Button>
        </DialogActions>
    </Dialog>
);


const BookList = memo(function BookList() {
  // Hooks (bleiben gleich)
  const { token, logout, userPayload } = useAuth();
  const {
      books, totalPages, currentPage, isLoading: isLoadingBooks, error: booksError,
      handleSearch, handlePageChange, addBook, deleteBook, reloadBooks,
      searchTerm,
      sortConfig, handleSortChange,
      addressFilter, roomFilter, shelfFilter, compartmentFilter,
      handleHierarchicalFilterChange,
      // *** NEU: Rating-Filter und Handler aus useBooks holen ***
      ratingFilter,
      handleRatingFilterChange
  } = useBooks();
  const { locations, isLoading: isLoadingLocations, error: locationsError, fetchLocations } = useLocations();
  const { columns, isLoadingProfile, error: columnsError, preferredView, allColumnsConfig } = useUserPreferences();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  // UI State (bleibt gleich)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  const [openProfileDialog, setOpenProfileDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null);
  const [openDetailDialog, setOpenDetailDialog] = useState(false);
  const [selectedBookDetail, setSelectedBookDetail] = useState(null);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [newBookIsbn, setNewBookIsbn] = useState('');
  const [newBookLocation, setNewBookLocation] = useState(null);
  const [openBarcodeScanner, setOpenBarcodeScanner] = useState(false);
  const [openLocationDialog, setOpenLocationDialog] = useState(false);
  const [openMassImportDialog, setOpenMassImportDialog] = useState(false);
  const [openStatsDialog, setStatsDialogOpen] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [isAddingBook, setIsAddingBook] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');
  const [confirmLogoutOpen, setConfirmLogoutOpen] = useState(false);
  const [showLoanedBooks, setShowLoanedBooks] = useState(false);

  // *** NEU: Ref für initialen Mount ***
  const isInitialMount = useRef(true);

  // --- Snackbar-Handler muss vor allen Callbacks stehen, die ihn nutzen! ---
  const showSnackbar = useCallback((message, severity = 'info') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  }, []);

  // --- State für ausgeliehene Bücher ---
  const [loanedBooks, setLoanedBooks] = useState([]);
  const [isLoadingLoans, setIsLoadingLoans] = useState(false);
  const [loansError, setLoansError] = useState(null);
  const loadLoanedBooks = useCallback(async () => {
    setIsLoadingLoans(true);
    setLoansError(null);
    try {
      const data = await fetchCurrentLoansAPI();
      setLoanedBooks(data);
    } catch (err) {
      setLoansError(err.message);
    } finally {
      setIsLoadingLoans(false);
    }
  }, []);
  useEffect(() => { loadLoanedBooks(); }, [loadLoanedBooks]);

  // --- Handler für Rückgabe aus der Liste ---
  const handleReturnFromList = useCallback(async (loan) => {
    try {
      await returnBookAPI(loan.book._id);
      showSnackbar('Buch als zurückgegeben markiert.', 'success');
      // Kurzes Delay, damit UI-Animationen sauber abschließen
      await new Promise(res => setTimeout(res, 100));
      loadLoanedBooks();
      reloadBooks();
    } catch (err) {
      showSnackbar(`Fehler beim Zurückgeben: ${err.message}`, 'error');
    }
  }, [loadLoanedBooks, reloadBooks, showSnackbar]);

  // --- Gefilterte ausgeliehene Bücher für die Verliehen-Ansicht ---
  const filteredLoanedBooks = useMemo(() => {
    let filtered = loanedBooks.map(l => ({ ...l.book, _loan: l }));
    // Filter: Suchbegriff
    if (searchTerm) {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter(book =>
        (book.title && book.title.toLowerCase().includes(lower)) ||
        (book.authors && book.authors.join(', ').toLowerCase().includes(lower)) ||
        (book.isbn && book.isbn.toLowerCase().includes(lower))
      );
    }
    // Filter: Location
    if (addressFilter) {
      filtered = filtered.filter(book => book.location?.adresse === addressFilter);
    }
    if (roomFilter) {
      filtered = filtered.filter(book => book.location?.raum === roomFilter);
    }
    if (shelfFilter) {
      filtered = filtered.filter(book => book.location?.regal === shelfFilter);
    }
    if (compartmentFilter) {
      filtered = filtered.filter(book => book.location?.fach === compartmentFilter);
    }
    // Filter: Rating (optional, falls relevant für verliehene Bücher)
    if (ratingFilter) {
      // Hier ggf. anpassen, falls Loan-Objekt ein Rating enthält
      // filtered = filtered.filter(...)
    }
    return filtered;
  }, [loanedBooks, searchTerm, addressFilter, roomFilter, shelfFilter, compartmentFilter, ratingFilter]);

  // --- State to track cards being removed (for fade-out) ---
  const [removingCards, setRemovingCards] = useState({});

  // --- Handler for BookCardList to mark a card as removing ---
  const handleCardRemoving = useCallback((bookId) => {
    setRemovingCards(prev => ({ ...prev, [bookId]: true }));
  }, []);

  // --- Handler for BookCardList to clear removing state after fade-out ---
  const handleCardRemoved = useCallback((bookId) => {
    setRemovingCards(prev => {
      const copy = { ...prev };
      delete copy[bookId];
      return copy;
    });
  }, []);

  // --- Pass filtered books to BookCardList (exclude removing) ---
  const filteredLoanedBooksForCards = useMemo(() =>
    filteredLoanedBooks.filter(book => !removingCards[book._id]),
    [filteredLoanedBooks, removingCards]
  );

  // Loading & Error State (bleibt gleich)
  const isLoading = isLoadingBooks || isLoadingLocations || isLoadingProfile;
  const error = booksError || locationsError || columnsError;

  useEffect(() => { fetchLocations(); }, [fetchLocations]);

  // --- Ableitung der Filteroptionen mit useMemo --- (bleibt gleich)
  const uniqueAddresses = useMemo(() => {
      if (!locations) return [];
      return [...new Set(locations.map(loc => loc.adresse).filter(Boolean))].sort();
  }, [locations]);

  const uniqueRooms = useMemo(() => {
      if (!locations || !addressFilter) return []; // Nur wenn Adresse gewählt
      return [...new Set(locations
          .filter(loc => loc.adresse === addressFilter && loc.raum)
          .map(loc => loc.raum)
      )].sort();
  }, [locations, addressFilter]);

  const uniqueShelves = useMemo(() => {
      if (!locations || !addressFilter || !roomFilter) return []; // Nur wenn Adresse+Raum gewählt
      return [...new Set(locations
          .filter(loc => loc.adresse === addressFilter && loc.raum === roomFilter && loc.regal)
          .map(loc => loc.regal)
      )].sort();
  }, [locations, addressFilter, roomFilter]);

  const uniqueCompartments = useMemo(() => {
      if (!locations || !addressFilter || !roomFilter || !shelfFilter) return []; // Nur wenn Adresse+Raum+Regal gewählt
      return [...new Set(locations
          .filter(loc => loc.adresse === addressFilter && loc.raum === roomFilter && loc.regal === shelfFilter && loc.fach)
          .map(loc => loc.fach)
      )].sort();
  }, [locations, addressFilter, roomFilter, shelfFilter]);

  // --- Handler (useCallback für potenzielle Weitergabe an memoized Komponenten) ---
  const handleBarcodeDetected = useCallback((isbn) => {
    setNewBookIsbn(isbn);
    setOpenBarcodeScanner(false);
    setOpenAddDialog(true);
  }, []);

  const handleDeleteBook = useCallback(async (id) => {
      setDeletingId(id);
      try {
          await deleteBook(id);
          showSnackbar('Buch erfolgreich gelöscht.', 'success');
      } catch (err) {
          showSnackbar(`Fehler beim Löschen: ${err.message || 'Unbekannter Fehler'}`, 'error');
      } finally {
          setDeletingId(null);
      }
  }, [deleteBook, showSnackbar]); // deleteBook ist aus useBooks, sollte stabil sein

  // --- WICHTIG: Filter-/Such-/Rating-Handler setzen showLoanedBooks immer auf false ---
  const handleSearchWithReset = useCallback((term) => {
    setShowLoanedBooks(false);
    handleSearch(term);
  }, [handleSearch]);

  const handleHierarchicalFilterChangeWithReset = useCallback((type, value) => {
    setShowLoanedBooks(false);
    handleHierarchicalFilterChange(type, value);
  }, [handleHierarchicalFilterChange]);

  const handleRatingFilterChangeWithReset = useCallback((value) => {
    setShowLoanedBooks(false);
    handleRatingFilterChange(value);
  }, [handleRatingFilterChange]);

  const handleAddBookSubmit = useCallback(async (e) => {
    e.preventDefault();
    if (!newBookLocation) { showSnackbar('Bitte wähle einen Lagerort aus.', 'warning'); return; }
    if (!newBookIsbn) { showSnackbar('Bitte gib eine ISBN ein.', 'warning'); return; }
    setIsAddingBook(true);
    try {
        // Sende die ObjectId des Lagerorts
        await addBook({ isbn: newBookIsbn, location: newBookLocation });
        showSnackbar('Buch erfolgreich hinzugefügt.', 'success');
        setNewBookIsbn(''); setNewBookLocation(null); setOpenAddDialog(false);
    } catch (err) {
        const message = err.status === 409 ? err.message : `Fehler beim Hinzufügen: ${err.message || 'Unbekannter Fehler'}`;
        showSnackbar(message, 'error');
    } finally {
        setIsAddingBook(false);
    }
    // *** WICHTIG: newBookLocation ist die ObjectId ***
  }, [addBook, newBookIsbn, newBookLocation, showSnackbar]);

    // *** NEU: Mapping für Rating-Filter-Label ***
    const ratingFilterLabels = {
        read: 'Gelesen',
        wants_to_read: 'Will ich lesen',
        keep: 'Behalten',
        discard: 'Kann weg'
    };

  const handleEditOpen = useCallback((book) => { setSelectedBook(book); setOpenEditDialog(true); }, []);
  const handleEditClose = useCallback((shouldReload = false) => { setOpenEditDialog(false); setSelectedBook(null); if (shouldReload) reloadBooks(); }, [reloadBooks]);
  const handleDetailOpen = useCallback((book) => { setSelectedBookDetail(book); setOpenDetailDialog(true); }, []);
  const handleDetailClose = useCallback(() => { setOpenDetailDialog(false); setSelectedBookDetail(null); }, []);
  const handleAddOpen = useCallback(() => { setNewBookIsbn(''); setNewBookLocation(null); setOpenAddDialog(true); }, []);
  const handleAddClose = useCallback(() => { setOpenAddDialog(false); setNewBookIsbn(''); setNewBookLocation(null); }, []);
  const handleOpenLocationDialog = useCallback(() => {
      setIsDrawerOpen(false);
      setShowLoanedBooks(false); // Verliehen-Ansicht verlassen
      setOpenLocationDialog(true);
  }, []);
  const handleCloseLocationDialog = useCallback((shouldReload = false) => { setOpenLocationDialog(false); if (shouldReload) fetchLocations(); }, [fetchLocations]);
  const handleOpenMassImportDialog = useCallback(() => {
      setIsDrawerOpen(false);
      setShowLoanedBooks(false); // Verliehen-Ansicht verlassen
      setOpenMassImportDialog(true);
  }, []);
  const handleCloseMassImportDialog = useCallback(() => { setOpenMassImportDialog(false); }, []);
  const handleImportComplete = useCallback(() => { reloadBooks(); }, [reloadBooks]);
  const handleOpenStatsDialog = useCallback(() => {
      setIsDrawerOpen(false);
      setShowLoanedBooks(false); // Verliehen-Ansicht verlassen
      setStatsDialogOpen(true);
  }, []);
  const handleCloseStatsDialog = useCallback(() => { setStatsDialogOpen(false); }, []);
  const handleBarcodeOpen = useCallback(() => { setOpenBarcodeScanner(true); }, []);
  const handleBarcodeClose = useCallback(() => { setOpenBarcodeScanner(false); }, []);
  const handleSnackbarClose = useCallback((event, reason) => { if (reason === 'clickaway') return; setSnackbarOpen(false); }, []);

  // Handler für Hauptmenü-Drawer (ohne useCallback)
  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
    setIsDrawerOpen(open);
  };

  // *** NEUE Handler für Filter-Drawer ***
  const handleOpenFilterDrawer = useCallback(() => setIsFilterDrawerOpen(true), []); // useCallback hinzugefügt
  const handleCloseFilterDrawer = useCallback(() => setIsFilterDrawerOpen(false), []);
  // *** Ende NEUE Handler ***

  const handleOpenProfileDialog = useCallback(() => {
      setIsDrawerOpen(false);
      setShowLoanedBooks(false); // Verliehen-Ansicht verlassen
      setOpenProfileDialog(true);
  }, []);
  const handleCloseProfileDialog = useCallback(() => { setOpenProfileDialog(false); }, []);
  const handleLogoutFromDrawer = useCallback(() => { setIsDrawerOpen(false); logout(); }, [logout]);

  // *** NEUE Handler für Logout-Bestätigung ***
  const handleOpenConfirmLogout = useCallback(() => setConfirmLogoutOpen(true), []);
  const handleCloseConfirmLogout = useCallback(() => setConfirmLogoutOpen(false), []);
  const handleConfirmLogout = useCallback(() => {
      handleCloseConfirmLogout();
      logout();
  }, [logout, handleCloseConfirmLogout]);

  // *** NEUER Handler zum Navigieren zum Rater ***
  const handleOpenRater = useCallback(() => {
      setIsDrawerOpen(false);
      setShowLoanedBooks(false); // Verliehen-Ansicht verlassen
      navigate('/rate');
  }, [navigate]);

    // *** NEUER Handler zum Navigieren zur Admin-Seite ***
    const handleOpenAdmin = useCallback(() => {
        setIsDrawerOpen(false);
        setShowLoanedBooks(false); // Verliehen-Ansicht verlassen
        navigate('/admin');
    }, [navigate]);

  // --- Effekt für Back-Button Handling (Popstate Listener) ---
  useEffect(() => {
    // Füge beim Mounten den initialen State hinzu (Seite 1)
    window.history.pushState({ page: 1 }, '', window.location.href);
    console.log("Back button handler attached, initial state pushed { page: 1 }.");

    const handlePopstate = (event) => {
      // 1. Hole den State, zu dem zurücknavigiert werden *würde*
      const previousState = event.state;

      // 2. Sofort den *aktuellen* Seitenstatus wieder pushen, um auf der Seite zu bleiben
      window.history.pushState({ page: currentPage }, '', window.location.href);
      console.log(`Popstate occurred. Would go to state:`, previousState, `Current page: ${currentPage}. Pushed current state { page: ${currentPage} } back.`);

      // 3. Prüfe, ob Dialoge/Drawer offen sind (höchste Priorität)
      if (openEditDialog) { console.log("Back button: Closing Edit Dialog"); handleEditClose(false); return; }
      if (openDetailDialog) { console.log("Back button: Closing Detail Dialog"); handleDetailClose(); return; }
      if (openAddDialog) { console.log("Back button: Closing Add Dialog"); handleAddClose(); return; }
      if (openLocationDialog) { console.log("Back button: Closing Location Dialog"); handleCloseLocationDialog(false); return; }
      if (openMassImportDialog) { console.log("Back button: Closing Mass Import Dialog"); handleCloseMassImportDialog(); return; }
      if (openStatsDialog) { console.log("Back button: Closing Stats Dialog"); handleCloseStatsDialog(); return; }
      if (openProfileDialog) { console.log("Back button: Closing Profile Dialog"); handleCloseProfileDialog(); return; }
      if (isFilterDrawerOpen) { console.log("Back button: Closing Filter Drawer"); handleCloseFilterDrawer(); return; }
      if (openBarcodeScanner) { console.log("Back button: Closing Barcode Scanner"); handleBarcodeClose(); return; }

      // 4. Kein Dialog offen - Paginierung oder Logout prüfen
      const targetPage = previousState?.page; // Die Seite, zu der zurückgegangen werden sollte

      // Wenn eine vorherige Seite im State existiert UND sie anders ist als die aktuelle Seite
      if (targetPage !== undefined && targetPage !== null && targetPage !== currentPage) {
          console.log(`Back button: Navigating from page ${currentPage} to page ${targetPage}`);
          handlePageChange(targetPage); // Navigiere zur vorherigen Seite
      }
      // Wenn wir auf Seite 1 sind UND der Zielstatus Seite 1 oder der initiale (null/undefined) ist
      else if (currentPage === 1 && (targetPage === 1 || targetPage === undefined || targetPage === null)) {
          console.log("Back button: On page 1, showing logout confirmation");
          handleOpenConfirmLogout(); // Zeige Logout-Dialog
      }
      // Fallback/Edge Case: Zielseite ist gleich aktueller Seite oder ungültig, aber wir sind nicht auf Seite 1
      // In diesem Fall machen wir nichts (oder könnten zur Sicherheit auf Seite 1 gehen)
      else {
          console.warn(`Back button: Unhandled state or target page (${targetPage}) is same as current page (${currentPage}). No navigation action taken.`);
          // Optional: handlePageChange(1); // Zurück zu Seite 1 als sicherer Fallback?
      }
    };

    // Füge den Event Listener hinzu
    window.addEventListener('popstate', handlePopstate);

    // Cleanup-Funktion: Entferne den Listener beim Unmounten
    return () => {
      window.removeEventListener('popstate', handlePopstate);
      console.log("Back button handler removed.");
    };
  }, [ // Abhängigkeiten: Alle States/Handler, die im Popstate-Handler verwendet werden
      currentPage, handlePageChange, // Wichtig für Paginierungslogik
      openEditDialog, handleEditClose,
      openDetailDialog, handleDetailClose,
      openAddDialog, handleAddClose,
      openLocationDialog, handleCloseLocationDialog,
      openMassImportDialog, handleCloseMassImportDialog,
      openStatsDialog, handleCloseStatsDialog,
      openProfileDialog, handleCloseProfileDialog,
      isFilterDrawerOpen, handleCloseFilterDrawer,
      openBarcodeScanner, handleBarcodeClose,
      handleOpenConfirmLogout // Handler zum Öffnen des Logout-Dialogs
  ]);
  // --- Ende Effekt für Back-Button Handling ---


  // --- Effekt zum Pushen des Seitenstatus bei Paginierungsänderung ---
  useEffect(() => {
      // Überspringe den initialen Mount, da der initiale State schon im anderen Effekt gesetzt wird
      if (isInitialMount.current) {
          isInitialMount.current = false;
          return;
      }

      // Nur pushen, wenn sich die Seite tatsächlich geändert hat (sollte durch useBooks sichergestellt sein)
      console.log(`Pagination detected: Pushing state { page: ${currentPage} } to history.`);
      window.history.pushState({ page: currentPage }, '', window.location.href);

  }, [currentPage]); // Reagiert auf Änderungen der currentPage
  // --- Ende Effekt für Paginierungsänderung ---


  // SpeedDial Actions (bleibt gleich)
  const fabActions = [
    { icon: <QrCodeScannerIcon />, name: 'Barcode scannen', handler: handleBarcodeOpen },
    { icon: <AddIcon />, name: 'Manuell hinzufügen', handler: handleAddOpen },
  ];

  // Prüfen, ob Filter aktiv sind (jetzt auch Rating-Filter prüfen)
  const locationFiltersActive = !!addressFilter || !!roomFilter || !!shelfFilter || !!compartmentFilter;
  const filtersActive = locationFiltersActive || !!ratingFilter; // Gesamt-Filterstatus

  // Rendering
  if (error && !snackbarOpen) { /* ... */ }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      {/* AppBar */}
      <AppBar position="sticky">
          <Toolbar>
            <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} onClick={toggleDrawer(true)}> <MenuIcon /> </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}> Familiothek </Typography>
            <UserAccount userPayload={userPayload} onLogout={logout} />
          </Toolbar>
      </AppBar>

      {/* Hauptinhalt */}
      <Box component="main" sx={{ flexGrow: 1, p: { xs: 1, sm: 2, md: 3 }, overflowY: 'auto' }}>
        {/* --- NEU: Verliehen-Ansicht ersetzt die Hauptliste --- */}
        {showLoanedBooks ? (
          <Box sx={{ p: 2 }}>
            <Typography variant="h5" gutterBottom>Verliehene Bücher</Typography>
            {/* Suchleiste und Filter-Button auch in Verliehen-Ansicht */}
            <Stack direction="row" spacing={1} alignItems="center" mb={1}>
              <Box sx={{ flexGrow: 1 }}> <BookSearch onSearch={handleSearchWithReset} searchTerm={searchTerm} /> </Box>
              <IconButton onClick={handleOpenFilterDrawer} aria-label="Filter öffnen"> <Badge color="secondary" variant="dot" invisible={!filtersActive}> <FilterListIcon /> </Badge> </IconButton>
            </Stack>
            {(locationFiltersActive || ratingFilter) && (
              <Stack direction="row" spacing={1} flexWrap="wrap" mb={2} sx={{ pl: { xs: 0, sm: 0.5 } }}>
                {/* ...Filter Chips... */}
              </Stack>
            )}
            <Paper elevation={3} sx={{ mb: 3, overflow: 'hidden' }}>
              <Box sx={{ position: 'relative', minHeight: '300px' }}>
                {isLoadingLoans ? (
                  <CircularProgress sx={{ m: 2 }} />
                ) : loansError ? (
                  <Alert severity="error">{loansError}</Alert>
                ) : (
                  preferredView === 'card' ? (
                    <BookCardList
                      books={filteredLoanedBooksForCards}
                      handleEditOpen={handleEditOpen}
                      handleDelete={handleDeleteBook}
                      handleDetailOpen={handleDetailOpen}
                      deletingId={deletingId}
                      handleReturnFromList={async (loan) => {
                        // Mark as removing, then call original handler
                        handleCardRemoving(loan.book._id);
                        await handleReturnFromList(loan);
                        // After fade-out, remove from removing state
                        setTimeout(() => handleCardRemoved(loan.book._id), 400);
                      }}
                    />
                  ) : (
                    columns.length > 0 ? (
                      <BookTable
                        books={filteredLoanedBooks}
                        sortConfig={{ orderBy: sortConfig.sortBy, order: sortConfig.sortOrder }}
                        requestSort={handleSortChange}
                        handleEditOpen={handleEditOpen}
                        handleDelete={handleDeleteBook}
                        handleDetailOpen={handleDetailOpen}
                        columns={columns}
                        deletingId={deletingId}
                        handleReturnFromList={handleReturnFromList}
                      />
                    ) : (
                      <Typography sx={{p: 2}}>Spaltenkonfiguration wird geladen...</Typography>
                    )
                  )
                )}
              </Box>
            </Paper>
            <Button variant="outlined" onClick={() => { setShowLoanedBooks(false); reloadBooks(); }} sx={{ mt: 2 }}>Zurück zur Übersicht</Button>
          </Box>
        ) : (
          // ...normale Buchlistenansicht...
          <>
            {/* Suchleiste und Filter-Button */}
            <Stack direction="row" spacing={1} alignItems="center" mb={1}>
              <Box sx={{ flexGrow: 1 }}> <BookSearch onSearch={handleSearchWithReset} searchTerm={searchTerm} /> </Box>
              <IconButton onClick={handleOpenFilterDrawer} aria-label="Filter öffnen"> <Badge color="secondary" variant="dot" invisible={!filtersActive}> <FilterListIcon /> </Badge> </IconButton>
            </Stack>
            {/* Aktive Filter Chips */}
            {(locationFiltersActive || ratingFilter) && (
              <Stack direction="row" spacing={1} flexWrap="wrap" mb={2} sx={{ pl: { xs: 0, sm: 0.5 } }}>
                {/* ...Filter Chips... */}
              </Stack>
            )}
            {/* Buchliste (Tabelle/Karten) */}
            <Paper elevation={3} sx={{ mb: 3, overflow: 'hidden' }}>
              <Box sx={{ position: 'relative', minHeight: '300px' }}>
                {!isLoading && ( preferredView === 'card' ? (
                  <BookCardList books={books} handleEditOpen={handleEditOpen} handleDelete={handleDeleteBook} handleDetailOpen={handleDetailOpen} deletingId={deletingId} />
                ) : (
                  columns.length > 0 ? (
                    <BookTable books={books} sortConfig={{ orderBy: sortConfig.sortBy, order: sortConfig.sortOrder }} requestSort={handleSortChange} handleEditOpen={handleEditOpen} handleDelete={handleDeleteBook} handleDetailOpen={handleDetailOpen} columns={columns} deletingId={deletingId} />
                  ) : (
                    <Typography sx={{p: 2}}>Spaltenkonfiguration wird geladen...</Typography>
                  )
                ))}
              </Box>
            </Paper>
            {/* Paginierung */}
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
              <BookPagination totalPages={totalPages} currentPage={currentPage} onPageChange={handlePageChange} />
            </Box>
          </>
        )}
      </Box> {/* Ende Hauptinhalt */}

      {/* Hauptmenü-Drawer (links) */}
<Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)}>
    <Box sx={{ width: 250 }} role="presentation">
        <Toolbar /> <Divider />
        {/* *** NEU: Filter-Sektion *** */}
        <List subheader={<Typography variant="overline" sx={{ pl: 2 }}>Filter</Typography>}>
            <ListItem disablePadding>
                <ListItemButton
                    selected={ratingFilter === null}
                    onClick={() => { handleRatingFilterChangeWithReset(null); setIsDrawerOpen(false); }}
                >
                    <ListItemIcon><ClearAllIcon /></ListItemIcon>
                    <ListItemText primary="Alle Bücher" />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton
                    selected={ratingFilter === 'read'}
                    onClick={() => { handleRatingFilterChangeWithReset('read'); setIsDrawerOpen(false); }}
                >
                    <ListItemIcon><CheckCircleOutlineIcon /></ListItemIcon>
                    <ListItemText primary="Gelesen" />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton
                    selected={ratingFilter === 'wants_to_read'}
                    onClick={() => { handleRatingFilterChangeWithReset('wants_to_read'); setIsDrawerOpen(false); }}
                >
                    <ListItemIcon><BookmarkBorderIcon /></ListItemIcon>
                    <ListItemText primary="Will ich lesen" />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton
                    selected={ratingFilter === 'keep'}
                    onClick={() => { handleRatingFilterChangeWithReset('keep'); setIsDrawerOpen(false); }}
                >
                    <ListItemIcon><FavoriteBorderIcon /></ListItemIcon>
                    <ListItemText primary="Behalten" />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
                <ListItemButton
                    selected={ratingFilter === 'discard'}
                    onClick={() => { handleRatingFilterChangeWithReset('discard'); setIsDrawerOpen(false); }}
                >
                    <ListItemIcon><DeleteOutlineIcon /></ListItemIcon>
                    <ListItemText primary="Kann weg" />
                </ListItemButton>
            </ListItem>
            {/* --- NEU: Menüpunkt für ausgeliehene Bücher direkt unter 'Kann weg' --- */}
            <ListItem disablePadding>
                <ListItemButton onClick={() => { setIsDrawerOpen(false); setShowLoanedBooks(true); }}>
                    <ListItemIcon><AssignmentReturnIcon /></ListItemIcon>
                    <ListItemText primary="Verliehen" />
                </ListItemButton>
            </ListItem>
        </List>
        <Divider />
              {/* *** ENDE NEU: Filter-Sektion *** */}

              <List subheader={<Typography variant="overline" sx={{ pl: 2 }}>Aktionen & Verwaltung</Typography>}>
                  {/* Bestehende Menüpunkte */}
                  <ListItem disablePadding> <ListItemButton onClick={() => { handleOpenLocationDialog(); setIsDrawerOpen(false); }}> <ListItemIcon> <LocationOnIcon /> </ListItemIcon> <ListItemText primary="Lagerorte" /> </ListItemButton> </ListItem>
                  <ListItem disablePadding> <ListItemButton onClick={() => { handleOpenMassImportDialog(); setIsDrawerOpen(false); }}> <ListItemIcon> <UploadFileIcon /> </ListItemIcon> <ListItemText primary="Massenimport" /> </ListItemButton> </ListItem>
                  <ListItem disablePadding> <ListItemButton onClick={() => { handleOpenStatsDialog(); setIsDrawerOpen(false); }}> <ListItemIcon> <BarChartIcon /> </ListItemIcon> <ListItemText primary="Statistiken" /> </ListItemButton> </ListItem>
                  <ListItem disablePadding> <ListItemButton onClick={handleOpenRater}> <ListItemIcon> <RateReviewIcon /> </ListItemIcon> <ListItemText primary="Bücher bewerten" /> </ListItemButton> </ListItem>
              </List>     <ListItem disablePadding>
                      <ListItemButton onClick={handleOpenAdmin}>
                          <ListItemIcon> <AdminPanelSettingsIcon /> </ListItemIcon>
                          <ListItemText primary="Admin Bereich" />
                      </ListItemButton>
                  </ListItem>
              <Divider />
              <List>
                  {/* Bestehende Menüpunkte */}
                  <ListItem disablePadding> <ListItemButton onClick={() => { handleOpenProfileDialog(); setIsDrawerOpen(false); }}> <ListItemIcon> <SettingsIcon /> </ListItemIcon> <ListItemText primary="Profil & Einstellungen" /> </ListItemButton> </ListItem>
                  <ListItem disablePadding> <ListItemButton onClick={handleLogoutFromDrawer}> <ListItemIcon> <LogoutIcon /> </ListItemIcon> <ListItemText primary="Logout" /> </ListItemButton> </ListItem>
              </List>
    </Box>
</Drawer>

      {/* Filter-Drawer (rechts) */}
      <Drawer anchor="right" open={isFilterDrawerOpen} onClose={handleCloseFilterDrawer}>
          <Box sx={{ width: { xs: '85vw', sm: 300 }, p: 2 }} role="presentation"> <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}> <Typography variant="h6">Filter nach Ort</Typography> <IconButton onClick={handleCloseFilterDrawer} aria-label="Filter schließen"> <CloseIcon /> </IconButton> </Stack> <Divider sx={{ mb: 2 }} /> <Stack spacing={2}> <Autocomplete options={['Alle Adressen', ...uniqueAddresses]} value={addressFilter || 'Alle Adressen'} onChange={(event, newValue) => { handleHierarchicalFilterChangeWithReset('address', newValue === 'Alle Adressen' ? null : newValue); }} renderInput={(params) => <TextField {...params} label="Adresse" size="small" />} size="small" disabled={isLoadingLocations} disableClearable /> <Autocomplete options={['Alle Räume', ...uniqueRooms]} value={roomFilter || 'Alle Räume'} onChange={(event, newValue) => { handleHierarchicalFilterChangeWithReset('room', newValue === 'Alle Räume' ? null : newValue); }} renderInput={(params) => <TextField {...params} label="Raum" size="small" />} size="small" disabled={!addressFilter || isLoadingLocations} disableClearable key={`drawer-room-${addressFilter}`} /> <Autocomplete options={['Alle Regale', ...uniqueShelves]} value={shelfFilter || 'Alle Regale'} onChange={(event, newValue) => { handleHierarchicalFilterChangeWithReset('shelf', newValue === 'Alle Regale' ? null : newValue); }} renderInput={(params) => <TextField {...params} label="Regal" size="small" />} size="small" disabled={!addressFilter || !roomFilter || isLoadingLocations} disableClearable key={`drawer-shelf-${addressFilter}-${roomFilter}`} /> <Autocomplete options={['Alle Fächer', ...uniqueCompartments]} value={compartmentFilter || 'Alle Fächer'} onChange={(event, newValue) => { handleHierarchicalFilterChangeWithReset('compartment', newValue === 'Alle Fächer' ? null : newValue); }} renderInput={(params) => <TextField {...params} label="Fach" size="small" />} size="small" disabled={!addressFilter || !roomFilter || !shelfFilter || isLoadingLocations} disableClearable key={`drawer-comp-${addressFilter}-${roomFilter}-${shelfFilter}`} /> <Button onClick={() => { handleHierarchicalFilterChangeWithReset('address', null); }} disabled={!filtersActive} variant="outlined" size="small" sx={{ mt: 1 }} > Alle Filter zurücksetzen </Button> </Stack> </Box>
      </Drawer>

      {/* Speed Dial FAB */}
      <SpeedDial ariaLabel="Hinzufügen Optionen" sx={{ position: 'fixed', bottom: 16, right: 16 }} icon={<SpeedDialIcon />}>
          {fabActions.map((action) => ( <SpeedDialAction key={action.name} icon={action.icon} tooltipTitle={action.name} onClick={action.handler} tooltipOpen /> ))}
      </SpeedDial>

      {/* Dialoge */}
      <BarcodeScanner open={openBarcodeScanner} onClose={handleBarcodeClose} onBarcodeDetected={handleBarcodeDetected} />
      <LocationDialog open={openLocationDialog} onClose={handleCloseLocationDialog} />
      <MassImportDialog open={openMassImportDialog} onClose={handleCloseMassImportDialog} locations={locations} onImportComplete={handleImportComplete} getOptionLabel={getLocationLabel} />
      <StatsDialog open={openStatsDialog} onClose={handleCloseStatsDialog} />
      <UserProfile open={openProfileDialog} onClose={handleCloseProfileDialog} />
      {/* Add Book Dialog */}
      <Dialog open={openAddDialog} onClose={handleAddClose} fullScreen={isMobile} fullWidth maxWidth="sm">
          {isMobile && ( <AppBar sx={{ position: 'relative' }}> <Toolbar> <IconButton edge="start" color="inherit" onClick={handleAddClose} aria-label="close" disabled={isAddingBook}> <CloseIcon /> </IconButton> <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div"> Buch hinzufügen </Typography> <LoadingButton color="inherit" onClick={handleAddBookSubmit} loading={isAddingBook} loadingPosition="start" startIcon={<SaveIcon />} disabled={isAddingBook || !newBookIsbn || !newBookLocation} > Speichern </LoadingButton> </Toolbar> </AppBar> )}
          {!isMobile && ( <DialogTitle sx={{ m: 0, p: 2, bgcolor: 'primary.main', color: 'white' }}> Buch hinzufügen <IconButton aria-label="close" onClick={handleAddClose} sx={{ position: 'absolute', right: 8, top: 8, color: 'white' }} disabled={isAddingBook}> <CloseIcon /> </IconButton> </DialogTitle> )}
          <DialogContent sx={isMobile ? { pt: 2 } : {}}> <TextField autoFocus margin="dense" id="isbn" label="ISBN" type="text" fullWidth variant="outlined" value={newBookIsbn} onChange={(e) => setNewBookIsbn(e.target.value)} disabled={isAddingBook} /> <Autocomplete id="location-select-add" sx={{ mt: 2 }} options={locations} getOptionLabel={getLocationLabel} isOptionEqualToValue={(option, value) => option?._id === value?._id} value={locations.find(loc => loc._id === newBookLocation) || null} onChange={(event, value) => setNewBookLocation(value ? value._id : null)} disabled={isAddingBook} renderInput={(params) => ( <TextField {...params} label="Lagerort" variant="outlined" required error={!newBookLocation && !!newBookIsbn} /> )} /> </DialogContent>
          <DialogActions>
            <Button onClick={handleAddClose} disabled={isAddingBook}>Abbrechen</Button>
            <LoadingButton onClick={handleAddBookSubmit} variant="contained" color="primary" loading={isAddingBook} loadingPosition="start" startIcon={<SaveIcon />} disabled={isAddingBook || !newBookIsbn || !newBookLocation} > Speichern </LoadingButton>
          </DialogActions>
      </Dialog>
      <Dialog open={openDetailDialog} onClose={handleDetailClose} fullScreen={isMobile} fullWidth maxWidth="md">
        {selectedBookDetail && (
          <BookDetail bookId={selectedBookDetail._id} onClose={handleDetailClose} isEditMode={false} locations={locations} onActionComplete={loadLoanedBooks} isMobile={isMobile} />
        )}
      </Dialog>
      <ConfirmLogoutDialog
          open={confirmLogoutOpen}
          onClose={handleCloseConfirmLogout}
          onConfirm={handleConfirmLogout}
      />

      {/* Snackbar */}
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        {snackbarMessage ? (
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }} variant="filled">
            {snackbarMessage}
          </Alert>
        ) : null}
      </Snackbar>
    </Box>
  );
});

export default BookList;
